// Footer/index.js
import Footer from './Footer';
export default Footer;
